import api from "./client";

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function unwrapData(response) {
  if (response && typeof response === "object" && "data" in response) {
    return response.data;
  }

  return response;
}

export async function listAiConversations(limit = 20) {
  const response = await api.get(`ai/conversations?limit=${encodeURIComponent(limit)}`);
  const data = unwrapData(response);

  return asArray(data?.conversations);
}

export async function getAiConversation(conversationId) {
  const response = await api.get(`ai/conversations/${conversationId}`);
  const data = unwrapData(response);

  return data?.conversation || null;
}

export async function sendAiMessage(payload = {}) {
  const body = {
    message: String(payload.message || "").trim(),
    locale: payload.locale || undefined,
    requested_agent: payload.requestedAgent || undefined,
  };

  if (payload.conversationId) {
    body.conversation_id = Number(payload.conversationId);
  }

  return api.post("ai/chat", body);
}
